




import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color} from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";

@Component({
})
export default class ColorPicker extends Mixins(ModelEditableMixin) {
  editingSource: Color;

  @Prop()
  pallet: Color[];

  @Prop()
  defaultColor: Color;

  get defaultColorCode(): string {
    return this.defaultColor
      ? this.defaultColor.value
      : "transparent";  // バックエンドに返却するときにnullに変換される
  }

  get _colors(): { key: RegExp, convert: (s: string) => string }[] {
    return [
      { key: new RegExp("^#[0-9A-Fa-f]{4}$"), convert: (s: string) => s.charAt(0) + s.charAt(1).repeat(2) + s.charAt(2).repeat(2) + s.charAt(3).repeat(2)},
      { key: new RegExp("^#[0-9A-Fa-f]{8}$"), convert: (s: string) => s.substring(0, 7)},
      { key: new RegExp("^rgba\s?\(\s?((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s?\,\s?){3}(0(\.\d+)?|1(\.0+)?)\s?\)$"), convert: (s: string) => {
        const rgb = s.split(/\(|\)|,/).slice(1, 4);
        return "#" + parseInt(rgb[0], 16) + parseInt(rgb[1], 16) + parseInt(rgb[2], 16);
      }},
    ];
  }

  private toRgb(color: string): string {
    const converter = Enumerable.from(this._colors).where(c => c.key.test(color)).firstOrDefault();
    return converter
      ? converter.convert(color)
      : color;
  }

  get color(): string {
    // el-color-pickerのクリアはnull.transparentや無効値はnullに変換.
    return (this.editingSource && this.editingSource.value && (this.editingSource.value !== "transparent"))
      ? this.toRgb(this.editingSource.value)
      : null;
  }

  set color(value: string) {
    // el-color-pickerのクリアはnull.デフォルト色へ変換.
    this.writeProperty(s => s.value = value ? value : this.defaultColorCode);
  }

  get palletColors(): string[] {
    return Enumerable.from(this.pallet)
      .select(p => p.value)
      .toArray();
  }
}
